import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './WelcomeSection.css';

const CONTAIN_MODE_GRADIENT =
  'linear-gradient(90deg, rgba(12, 30, 78, 1) 33%, rgba(13, 45, 102, 1) 81%)';

const propTypes = {
  heroImage: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  textColor: PropTypes.string,
  isHeroContainMode: PropTypes.bool
};

const WelcomeSection = ({
  heroImage,
  title,
  text,
  textColor,
  isHeroContainMode
}) => {
  const dynamicStyles = {};

  if (isHeroContainMode) {
    dynamicStyles.backgroundImage = heroImage
      ? `url(${heroImage}), ${CONTAIN_MODE_GRADIENT}`
      : CONTAIN_MODE_GRADIENT;
  } else if (heroImage) {
    dynamicStyles.backgroundImage = `url(${heroImage})`;
  }

  const textStyle = {
    color: textColor
  };

  const containerClass = classNames(styles.container, {
    [styles['contain-mode']]: isHeroContainMode
  });

  return (
    <div
      className={containerClass}
      style={dynamicStyles}
      data-test-id="welcome-section-container"
    >
      <header
        className={styles.content}
        data-test-id="welcome-section"
        aria-labelledby="welcome-title"
      >
        <h1
          id="welcome-title"
          className={styles.title}
          style={textStyle}
          data-test-id="welcome-title"
        >
          {title}
        </h1>
        <h2
          className={styles.text}
          style={textStyle}
          data-test-id="welcome-text"
        >
          {text}
        </h2>
      </header>
    </div>
  );
};

WelcomeSection.defaultProps = {
  heroImage: '',
  title: '',
  text: '',
  textColor: '#FFF',
  isHeroContainMode: false
};

WelcomeSection.propTypes = propTypes;

export default WelcomeSection;
